import { useState } from "react";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import { TextField, Popover, Icon, Grid } from "@mui/material";
import moment from "moment";
import { MONTH_LABELS, THEME_COLORS } from "layouts/reports/reports.constants";

const monthFieldSx = {
  cursor: "pointer",
  width: 160,
  "& .MuiInputBase-root": {
    minHeight: "15px",
    height: "35px !important",
    padding: "0 12px !important",
    borderRadius: "0.5rem !important",
    fontSize: "12px !important",
    border: "none",
    boxShadow: "none",
    cursor: "pointer",
  },
  "& .MuiInputBase-input": {
    height: "100% !important",
    fontSize: "12px",
    cursor: "pointer",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": { border: "none" },
    "&:hover fieldset": { border: "none" },
    "&.Mui-focused fieldset": { border: "none" },
  },
};

function MonthPicker({ value, onChange, placeholder = "Select Month" }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [pickerYear, setPickerYear] = useState(moment(value, "YYYY-MM").year());

  return (
    <SuiBox sx={{ height: "35px", display: "flex", alignItems: "center" }}>
      <TextField
        value={moment(value, "YYYY-MM").format("MMMM YYYY")}
        placeholder={placeholder}
        onClick={(e) => {
          setPickerYear(moment(value, "YYYY-MM").year());
          setAnchorEl(e.currentTarget);
        }}
        InputProps={{ readOnly: true }}
        size="small"
        sx={monthFieldSx}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{ sx: { backgroundColor: THEME_COLORS.white } }}
      >
        <SuiBox p={2} sx={{ width: 220, backgroundColor: THEME_COLORS.white }}>
          <SuiBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <Icon sx={{ cursor: "pointer" }} onClick={() => setPickerYear((y) => y - 1)}>
              chevron_left
            </Icon>
            <SuiTypography variant="button" fontWeight="bold">
              {pickerYear}
            </SuiTypography>
            <Icon
              sx={{
                cursor: pickerYear < moment().year() ? "pointer" : "default",
                opacity: pickerYear < moment().year() ? 1 : 0.3,
              }}
              onClick={() => pickerYear < moment().year() && setPickerYear((y) => y + 1)}
            >
              chevron_right
            </Icon>
          </SuiBox>
          <Grid container spacing={1}>
            {MONTH_LABELS.map((label, index) => {
              const isSelected = value === `${pickerYear}-${String(index + 1).padStart(2, "0")}`;
              const isFuture = pickerYear === moment().year() && index > moment().month();
              return (
                <Grid item xs={4} key={label}>
                  <SuiBox
                    onClick={() => {
                      if (isFuture) return;
                      onChange(`${pickerYear}-${String(index + 1).padStart(2, "0")}`);
                      setAnchorEl(null);
                    }}
                    sx={{
                      textAlign: "center",
                      borderRadius: "0.5rem",
                      py: 1,
                      cursor: isFuture ? "default" : "pointer",
                      opacity: isFuture ? 0.35 : 1,
                      backgroundColor: isSelected ? THEME_COLORS.primary : "transparent",
                      "&:hover": {
                        backgroundColor: isFuture
                          ? "transparent"
                          : isSelected
                          ? THEME_COLORS.primary
                          : "#f0f0f0",
                      },
                    }}
                  >
                    <SuiTypography
                      variant="caption"
                      fontWeight="medium"
                      sx={{ color: isSelected ? THEME_COLORS.white : "inherit" }}
                    >
                      {label}
                    </SuiTypography>
                  </SuiBox>
                </Grid>
              );
            })}
          </Grid>
        </SuiBox>
      </Popover>
    </SuiBox>
  );
}

export default MonthPicker;
